module.exports = __webpack_public_path__ + "img/mor-read_02.63260757.jpg";